import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import UserService from "./services/user.service";

import { Form } from "react-bootstrap"
import Alert from 'react-bootstrap/Alert'
import { login } from "./actions/auth.js";
import { logout } from "./actions/auth.js";
import { WrapperApp } from "./App.js";
import ModalForgotPassword from "./ModalForgotPassword.js";

const Login = () => {

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      username: "",
      password: ""
    },
  });  

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector(state => state.auth);
  //const { user } = useSelector(state => state.auth);
  const [user, setUser] = useState("");

  
  useEffect(() => {
    UserService.getUserBoard().then( // note that getUserBoard from user.service.js is used here and login from auth.service.js is used on Login
      (response) => { 
        setUser(response.data);
      }
    )
    .catch((e) => {
      if (e.response.status == 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch(() => {

        });
      }
      console.log(e.response.status);
    });
    
  }, []);
  

  const { message } = useSelector(state => state.message);

  const dispatch = useDispatch();

  const onChangeUsername = (e) => {  
    //console.log(e.target.value);
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    //e.preventDefault();
    setLoading(true);
    
    if (!loading) {
      dispatch(login(e.username, e.password))
        .then((resp) => {
          console.log("login response:", resp);
          //props.history.push("/userprofile");
          //window.location.assign("/viewuserprofile/");
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    } 
    else {
      setLoading(false);
    }
  };

  if (isLoggedIn) { 
    //window.location.reload();
    //return <Navigate to="/" />;
    return <WrapperApp user={user}/>;    
  };

  return (
    <div className="col-md-12">
      <img src="./design.png" style={{opacity:'0.1', position:'absolute',width:'100%',top:'0',left:'0',height:'100vh',overflow:'hidden',objectFit:'cover'}}/>
      <Alert className='m-2' style={{textAlign:'center',opacity:'0.8'}} variant="primary">
        <h3>Welcome to Cabinet's Quick's Online Configurator!</h3>
        <div>Please, login to continue</div>
      </Alert>
      <div className="col-md-12"></div>
      <div 
        className="card card-container"
        style={{maxWidth:'350px',padding:'40px 40px',backgroundColor:'lightgray'}}>
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        <Form noValidate onSubmit={handleSubmit(handleLogin)}>
          <div className="form-group">
            <label className="m-2" htmlFor="username">Username</label>
            <Controller
              name="username"
              control={control}
              onChange={onChangeUsername}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Control
                  {...field}
                    className="m-2"
                    type="text"
                    isInvalid={errors.username}
                    //onChange={onChangeUsername}
                    //value={username}
                    
                />
              )}
            />
            {errors.username && (
              <Form.Control.Feedback type="invalid">
                Username is required
              </Form.Control.Feedback>
            )}          
          </div>
          <div className="form-group">
            <label className="m-2" htmlFor="password">Password</label>
            <Controller
              name="password"
              control={control}
              onChange={onChangePassword}
              rules={{ required: true }}              
              render={({ field }) => (
                <Form.Control
                  {...field}
                    className="m-2"
                    type="password"
                    isInvalid={errors.password}
                    //onChange={onChangePassword}
                    //value={password}
                />
              )}
            />
            {errors.password && (
              <Form.Control.Feedback type="invalid">
                Password is required
              </Form.Control.Feedback>
            )}
          </div>  

          {/**
          <div className="form-group">
            <label htmlFor="password">Password</label>            
            <input
              type="text"
              
              name="username"
              value={username}
              onChange={onChangeUsername}
              validations={[required]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={password}
              onChange={onChangePassword}
              validations={[required]}
            />
          </div>
          */}
          <div className="form-group">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Login</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <hr />
          <span style={{fontSize:'13px'}} >
            Don't have an account yet? Create one <a href="/auto-register">here</a>.
          </span>     
          <p style={{fontSize:'13px'}} >
            <ModalForgotPassword/>
          </p>                 
        </Form>
      </div>
    </div>
  );
};

export default Login;